<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";

const store = useStore();
const router = useRouter();
const route = useRoute();
const isRTL = computed(() => store.state.isRTL);
const sidebarMinimize = () => store.commit("sidebarMinimize");

const props = defineProps({
  to: {
    type: String,
    required: true,
  },
  navText: {
    type: String,
    required: true,
  },
});

const minimizeSidebar = () => {
  if (window.innerWidth < 1200) {
    sidebarMinimize();
  }
};

const handleClick = (event) => {
  event.preventDefault();
  
  // Eğer aynı route'daysa, force navigation yap
  if (route.path === props.to) {
    router.push({ path: props.to, query: { _t: Date.now() } });
  } else {
    router.push(props.to);
  }
  
  minimizeSidebar();
};
</script>
<template>
  <a href="#" class="nav-link" @click="handleClick">
    <div
      class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
    >
      <slot name="icon"></slot>
    </div>
    <span class="nav-link-text" :class="isRTL ? ' me-1' : 'ms-1'">{{
      navText
    }}</span>
  </a>
</template>
